import Modal, { ModalControlProps } from "../../layouts/Modal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";

interface ToolValueResultModalProps extends ModalControlProps {
  title: string;
  value: string;
  onCopy: () => void;
}

export default function ToolValueResultModal({
  open,
  setOpen,
  title,
  value,
  onCopy,
}: ToolValueResultModalProps) {
  return (
    <Modal open={open} setOpen={setOpen} width="sm:max-w-2xl">
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          <p className="text-sm text-gray-500 mt-1">Copy the generated value below.</p>
        </div>

        <textarea
          value={value}
          readOnly
          rows={4}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 bg-gray-50 focus:outline-none"
        />

        <div className="flex gap-2">
          <ButtonInput
            label="Close"
            isSubmit={false}
            onClick={() => setOpen(false)}
            classes="!bg-white !text-gray-700 !border !border-gray-300 hover:!bg-gray-50"
          />
          <ButtonInput label="Copy to Clipboard" isSubmit={false} onClick={onCopy} classes="" />
        </div>
      </div>
    </Modal>
  );
}
